import React from 'react';
import cn from 'classnames';
import style from './menu-item.mod.scss';
import MenuLink from './menu-link';
import { useMenu } from '../../../context/MenuContext';

const MenuItem = (props) => {
  const isMobile = props.mobile;
  const { isMenuOpen, toggleMenu } = useMenu();
  const classes = cn(style.item);

  const closeMenu = () => {
    isMobile && toggleMenu(!isMenuOpen);
  };

  return (
    <div className={classes} onClick={closeMenu}>
      <MenuLink {...props} key={props.anchor} mobile={isMobile} />
    </div>
  );
};

export default MenuItem;
